import axios from 'axios';
import qs from 'qs';
import {Message} from 'element-ui';
import store from '@/store'
import router from '../router'

axios.defaults.timeout = 200000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;


//POST传参序列化
axios.interceptors.request.use((config) => {
    config.data = config.data || {};
    let token = store.getters.token;
    config.data.token = token;
    config.data = qs.stringify(config.data);
    config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    };
    return config;
}, (error) => {
    Message({
        message: '参数错误',
        type: 'warning'
    });
    return Promise.reject(error);
});

//返回状态判断
axios.interceptors.response.use((res) => {
    if (res.status == 200) {
        return res;
    } else {
        return Promise.reject(res);
    }
}, (error) => {
    return Promise.reject(error);
});

export function post(url, params) {
    return axios.post(url, params)
        .then(response => {
            switch (response.data.code) {
                case 100:
                    router.push("/");
                    // console.log("1qqqqqqqqqq");
                    break;
                case 200:
                    return response.data.data;
                case 400:  //400 为提示类型错误
                    Message({
                        message: response.data.msg,
                        type: 'warning'
                    });
                    return Promise.reject(response.data.msg || 'error');
                case 500:
                    break;
                default:
                    return Promise.reject(response.data.msg || 'error');
            }
        })
        .catch((msg) => {
            return Promise.reject(msg || 'error')
        });
}
